import { render, staticRenderFns } from "./VTabVertical.vue?vue&type=template&id=7aa3a71f"
import script from "./VTabVertical.vue?vue&type=script&lang=js"
export * from "./VTabVertical.vue?vue&type=script&lang=js"
import style0 from "./VTabVertical.vue?vue&type=style&index=0&id=7aa3a71f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports